<template>
  <div v-if="visible || localVisible" class="cl-modal-mask" v-analytics-exposure="{ event: 'activity_opened', key: 'rebate_coupon_lottery', properties: { activity_id: 'rebate_coupon_lottery', activity_name: '返利券抽奖', activity_type: 'lottery' } }">
    <div class="cl-modal-panel" @click.stop>
      <button class="cl-modal-close" @click="closeModal">×</button>
      <div class="coupon-lottery">
        <div class="panel-topband">
          <div class="band-left">
            <span class="band-icon"><i class="fa fa-gift"></i></span>
            <div class="band-texts">
              <div class="band-title">{{ bannerTitle || $t('couponLottery.banner_title') }}</div>
              <div class="band-subtitle">{{ bannerSubtitle || $t('couponLottery.banner_subtitle') }}</div>
            </div>
          </div>

        </div>
        <div class="band-right">
          <button class="rules-btn" @click="showRulesPopup = true">
            <div class="rules-icon-circle">!</div>
            <span>{{ $t('couponLottery.rules_btn') }}</span>
          </button>
        </div>
        <div class="purple-banner">
          <div class="pill-left" @click="showCouponPopup = true" style="cursor: pointer;">
            <span class="pill-icon"><i class="fa fa-gift"></i></span>
            <div class="pill-texts">
              <div class="pill-title">{{ $t('couponLottery.daily_draw_title') }}</div>
              <div class="pill-sub">{{ dailyStatus }}</div>
            </div>
          </div>
          <div class="pill-right">
            <div class="pill-texts">
              <div class="pill-title">
                {{ $cache.getGameCode() === 'lycqkr'
                  ? `오늘 ${PayAmountLabel} 충전 시 추가 추첨 기회가 해제됩니다!`
                  : $t('couponLottery.unlock_extra_tip', { amount: PayAmount }) }}
              </div>
            </div>
            <div class="progress"><el-progress :percentage="percentage" :show-text="false" color="#EA893F"
                define-back-color="#fff"></el-progress></div>
          </div>
        </div>
        <el-tabs v-model="activeName" type="card" :class="{ 'is-single-tab': isPrizePoolHidden }" @tab-click="handleClick">
          <el-tab-pane v-if="!isPrizePoolHidden" :style="{ width: tabWidth }" :label="$t('couponLottery.tab_lucky_draw')" name="first">
            <div class="panel">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-card class="box-card" style="border-radius: .2rem" body-style="padding: 0px;">
                    <div class="pool-info">
                      <div class="pi-header">
                        <i class="el-icon-user"></i>
                        <span>{{ poolTitle }}</span>
                      </div>
                      <div class="pi-body">
                        <span class="pi-count">{{ userCount }}</span>
                        <span class="pi-unit">{{ $t('couponLottery.unit_people') }}</span>
                      </div>
                    </div>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card class="box-card" style="border-radius: .2rem" body-style="padding: 0px;">
                    <div class="next-draw">
                      <div class="nd-header">
                        <i class="el-icon-time"></i>
                        <span>{{ $t('couponLottery.next_draw') }}</span>
                      </div>
                      <div class="nd-body">
                        <div class="nd-time">
                          <span class="nd-date">{{ $t('couponLottery.tomorrow') }}</span>
                          <span class="nd-clock">10:00</span>
                        </div>
                        <div class="nd-countdown">{{ countdownDisplay }}</div>
                      </div>
                    </div>
                  </el-card>
                </el-col>
              </el-row>
              <el-card class="box-card" style="border-radius: .2rem;margin-top: 20px;"
                body-style="padding: 0px; background: linear-gradient(180deg, #FFE9D6 0%, #F7D3B4 100%);">
                <div class="reward-infos">
                  <div class="ri-header">
                    <i class="fa fa-gift" style="font-size: .3rem;"></i>
                    <span>{{ $t('couponLottery.reward_info') }}</span>
                  </div>
                  <div class="ri-body">
                    <div class="ri-left">
                      <div class="ri-row">{{ $t('couponLottery.reward_label') }}</div>
                      <div class="ri-row">{{ $t('couponLottery.winners_label') }}</div>
                      <div class="ri-row">{{ $t('couponLottery.max_use_label') }}</div>
                      <div class="ri-row">{{ $t('couponLottery.validity_label') }}</div>
                    </div>
                    <div class="ri-right">
                      <div class="ri-row">1{{ $t('couponLottery.unit_piece') }}</div>
                      <div class="ri-row">1{{ $t('couponLottery.unit_people') }}</div>
                      <div class="ri-row">{{ $t('couponLottery.recharge_amount', { amount: 49 }) }}</div>
                      <div class="ri-row">{{ $t('couponLottery.validity_hours', { hours: 24 }) }}</div>
                    </div>
                  </div>
                </div>
              </el-card>
              <el-card class="box-card" style="border-radius: .2rem;margin-top: 20px;"
                body-style="padding: 0px; background: #FCE7B3">
                <div class="rules-info">
                  <div class="rules-title">{{ $t('couponLottery.participation_rules') }}</div>
                  <ul class="rules-list">
                    <li>{{ $t('couponLottery.rule_1') }}</li>
                    <li>{{ $t('couponLottery.rule_2') }}</li>
                    <li>{{ $t('couponLottery.rule_3') }}</li>
                    <li>{{ $t('couponLottery.rule_4') }}</li>
                  </ul>
                </div>
              </el-card>
              <div class="result-cta">
                <button class="result-btn" :class="buttonClass" :disabled="isButtonDisabled" @click="handlShowWinPopup">
                  <i class="fa fa-gift" style="font-size: .3rem;"></i>
                  <span>{{ buttonText }}</span>
                </button>
              </div>
              <el-card class="box-card" style="border-radius: .2rem;margin-top: 20px;"
                body-style="padding: 0px; background: #FCE7B3">
                <div class="recent-list">
                  <div class="rl-title">{{ $t('couponLottery.recent_winners') }}</div>
                  <div class="rl-item" v-for="value in lotteryRecordList">
                    <span class="rl-name">{{ value.name }}</span>
                    <span class="rl-date">{{ value.time }}</span>
                  </div>
                </div>
              </el-card>

            </div>
          </el-tab-pane>
          <el-tab-pane :style="{ width: tabWidth }" :label="$t('couponLottery.tab_my_coupons')" name="second">
            <div class="panel">
              <el-card class="box-card" style="border-radius: .2rem" body-style="padding: 0px;">
                <div class="redemption-form">
                  <div class="rf-header">
                    <span class="rf-icon"><i class="fa fa-gift"></i></span>
                    <div class="rf-texts">
                      <div class="rf-title">{{ $t('couponLottery.redeem_code_title') }}</div>
                      <div class="rf-sub">{{ $t('couponLottery.redeem_code_sub') }}</div>
                    </div>
                  </div>
                  <div class="rf-main">
                    <input class="rf-input" v-model="redemptionCode"
                      :placeholder="$t('couponLottery.redeem_code_placeholder')" />
                    <button class="rf-btn" :class="{ 'is-loading': isExchanging }" @click="handleExchange"
                      :disabled="isExchanging">
                      <i v-if="isExchanging" class="fa fa-spinner fa-spin"></i>
                      <span v-else>{{ $t('couponLottery.redeem_btn') }}</span>
                    </button>
                  </div>
                  <div class="rf-tip">{{ $t('couponLottery.redeem_tip') }}</div>
                </div>
              </el-card>
              <div class="list-header">
                <span>{{ $t('couponLottery.available_coupons', {
                  count: Array.isArray(rebateDetails) ?
                    rebateDetails.length : 0
                }) }}</span>
              </div>
              <div class="coupon-list-container">
                <div class="coupon-ticket" v-for="(coupon, index) in rebateDetails" :key="index">
                  <div class="ct-left">
                    <div class="ct-head">
                      <span class="ct-tag"><i class="el-icon-s-ticket" style="font-size: .2rem;"></i> {{
                        $t('couponLottery.rebate_coupon') }}</span>
                    </div>
                    <div class="ct-discount">
                      <span class="ct-percent">{{ coupon.code }}</span>
                    </div>
                    <span class="ct-limit" v-if="coupon.limitedState === 1">{{ $t('couponLottery.limit_use', {
                      amount:
                        '49.99'
                    }) }}</span>
                    <div class="ct-time">
                      <span><i class="el-icon-time"></i> {{ getCountdown(coupon.endTime) }}</span>
                    </div>
                    <div class="ct-obtained">{{ $t('couponLottery.obtained_at') }}{{ coupon.obtainedTime }}</div>
                  </div>
                  <div class="ct-right">
                    <div class="ct-status">{{ $t('couponLottery.status_available') }}</div>
                  </div>
                </div>

              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>

    <!-- 返利券抽奖弹窗 -->
    <div v-show="showCouponPopup" class="coupon-popup-mask" @click.self="handlShowCouponPopup = false">
      <div class="coupon-popup-panel">
        <button class="coupon-popup-close" @click="showCouponPopup = false">×</button>
        <div class="coupon-popup-header">
          <div class="cp-title">{{ $t('couponLottery.popup_draw_title') }}</div>
          <div class="cp-subtitle">{{ $t('couponLottery.popup_draw_sub') }}</div>
        </div>
        <div class="coupon-popup-content">
          <div class="cp-image-box">
            <img :src="couponPopupImage"
              :alt="$t('couponLottery.coupon_alt')" class="cp-image">
          </div>
          <button class="cp-btn" :class="{ 'is-loading': isDrawing }" @click="handlShowCouponPopup"
            :disabled="isDrawing">
            <i v-if="isDrawing" class="fa fa-spinner fa-spin"></i>
            <span v-else>{{ $t('couponLottery.popup_confirm') }}</span>
          </button>
        </div>
        <div class="coupon-popup-footer">
          <div class="cp-probs">
            <div class="cp-prob-header">
              <div class="cp-footer-title">{{ $t('couponLottery.popup_probs_title') }}</div>
            </div>
            <div class="cp-prob-conter">
              <div class="cp-prob-col">
                <div class="cp-prob-row"
                  v-for="(prob, index) in probabilities.slice(0, Math.ceil(probabilities.length / 2))" :key="index">
                  <span>{{ $t('couponLottery.popup_prob', { label: prob.label, value: prob.value }) }}</span>
                </div>
              </div>
              <div class="cp-prob-divider"></div>
              <div class="cp-prob-col">
                <div class="cp-prob-row"
                  v-for="(prob, index) in probabilities.slice(Math.ceil(probabilities.length / 2))" :key="index">
                  <span>{{ $t('couponLottery.popup_prob', { label: prob.label, value: prob.value }) }}</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 结果展示弹窗 -->
    <div v-show="showResultPopup" class="coupon-popup-mask" @click.self="showResultPopup = false">
      <div class="coupon-popup-panel result-panel">
        <button class="coupon-popup-close" @click="showResultPopup = false">×</button>
        <div class="coupon-popup-header">
          <div class="cp-title">{{ $t('couponLottery.popup_draw_title') }}</div>
          <div class="cp-subtitle">{{ $t('couponLottery.popup_draw_sub') }}</div>
        </div>
        <div class="coupon-popup-content result-content">
          <div class="cp-image-box result-image-box">
            <img :src="RebateData.codeUrl || '~@/assets/image/Rebatecoupon.png'"
              :alt="$t('couponLottery.rebate_coupon_with_value', { percent: RebateData.code })"
              class="cp-image result-image">
          </div>
          <div class="result-info-box">
            <div class="result-main-text" v-html="$t('couponLottery.result_congrats', { percent: RebateData.code })">
            </div>
            <div class="result-sub-text">{{ $t('couponLottery.result_validity', { hours: 24 }) }}</div>
          </div>
          <button class="cp-btn confirm-btn" @click="showResultPopup = false">{{ $t('couponLottery.confirm') }}</button>
        </div>
      </div>
    </div>

    <!-- 未中奖弹窗 -->
    <div v-show="showLosePopup" class="coupon-popup-mask" @click.self="showLosePopup = false">
      <div class="coupon-popup-panel lose-panel">
        <button class="coupon-popup-close" @click="showLosePopup = false">×</button>
        <div class="coupon-popup-header lose-header">
          <div class="cp-title lose-title">{{ $t('couponLottery.lose_title') }}</div>
        </div>
        <div class="coupon-popup-content lose-content">
          <div class="lose-image-box">
            <div class="lose-icon-circle">
              <i class="el-icon-present"></i>
            </div>
          </div>
          <div class="lose-info-box">
            <div class="lose-main-text">{{ $t('couponLottery.lose_main') }}</div>
            <div class="lose-sub-text">{{ $t('couponLottery.lose_sub') }}</div>
          </div>
          <button class="cp-btn lose-confirm-btn" @click="showLosePopup = false">{{ $t('couponLottery.confirm')
          }}</button>
        </div>
      </div>
    </div>

    <!-- 中奖弹窗 (中文版) -->
    <div v-show="showWinPopup" class="coupon-popup-mask" @click.self="showWinPopup = false">
      <div class="coupon-popup-panel win-panel">
        <button class="coupon-popup-close" @click="showWinPopup = false">×</button>
        <div class="coupon-popup-header win-header">
          <div class="cp-title win-title">{{ $t('couponLottery.win_title') }}</div>
        </div>
        <div class="coupon-popup-content win-content">
          <div class="win-image-box">
            <img :src="prizeData.codeUrl"
              :alt="$t('couponLottery.rebate_coupon_with_value', { percent: prizeData.code })" class="win-coupon-img">
          </div>
          <div class="win-info-box">
            <div class="win-main-text">{{ $t('couponLottery.win_main', { percent: prizeData.code }) }}</div>
            <div class="win-sub-text">{{ $t('couponLottery.win_sub', { amount: '49.99', hours: 24 }) }}</div>
          </div>
          <button class="cp-btn win-confirm-btn" @click="showWinPopup = false">{{ $t('couponLottery.confirm')
          }}</button>
        </div>
      </div>
    </div>

    <!-- 返利券使用規則弹窗 -->
    <div v-show="showRulesPopup" class="coupon-popup-mask" @click.self="showRulesPopup = false">
      <div class="coupon-popup-panel rules-popup-panel">
        <button class="coupon-popup-close rules-close" @click="showRulesPopup = false">×</button>
        <div class="coupon-popup-header rules-popup-header">
          <div class="rules-header-content">
            <span class="rules-header-icon"><i class="fa fa-gift"></i></span>
            <span class="rules-header-title">{{ ($cache.getGameCode() === 'fzsgkr' || $cache.getGameCode() === 'lycqkr') ? '이벤트 룰' : $t('couponLottery.rules_popup_title') }}</span>
          </div>
        </div>
        <div class="rules-popup-body">
          <div class="rules-scroll-content">
            <div v-for="(section, sIndex) in rulesSections" :key="sIndex" class="rules-section">
              <div class="rules-sec-title">
                <i class="fa fa-gift"></i> {{ getRuleText(section.title) }}
              </div>
              <div v-for="(item, iIndex) in section.items" :key="iIndex" class="rules-item">
                <!-- 標語 (Slogan) -->
                <div v-if="item.slogan" class="rules-text slogan-text">
                  {{ getRuleText(item.slogan) }}
                </div>
                <!-- 小標題 -->
                <div v-if="item.subTitle" class="rules-item-sub" :style="{ marginTop: iIndex > 0 ? '10px' : '0' }">
                  {{ getRuleText(item.subTitle) }}
                </div>
                <!-- 規則內容 -->
                <template v-if="item.lines">
                  <div v-for="(line, lIndex) in item.lines" :key="lIndex" class="rules-text"
                    :class="{ 'is-indent': line.indent }">
                    {{ typeof line === 'string' ? getRuleText(line) : (line.prefix ? `${line.prefix} ` : '') + getRuleText(line.key) }}
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <TipsWindow ref="tips" style="z-index: 999999; font-weight: 700;"></TipsWindow>
  </div>

</template>

<script>
import '@/assets/css/couponLottery.css';
import { Message } from 'element-ui' // 添加这行
import axios from 'axios'
import TipsWindow from '../tipsWindow.vue'
import { getSecondLevelDomain } from '@/utils/index.js'
export default {
  name: 'CouponLottery',
  components: {
    TipsWindow
  },
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '' },
    bannerTitle: { type: String, default: '' },
    bannerSubtitle: { type: String, default: '' },
  },
  data() {
    return {
      roleInfo: this.$cache.getRoleInfo(),
      percentage: 0,
      activeName: this.$cache.getGameCode() == 'sgyjltw' || this.$cache.getGameCode() == 'fzsgkr' || this.$cache.getGameCode() == 'lycqkr' ? 'second' : 'first',
      redemptionCode: '',
      showCouponPopup: false,
      showResultPopup: false,
      showLosePopup: false,
      showWinPopup: false,
      showRulesPopup: false,
      isExchanging: false,
      isDrawing: false,
      userCount: 0,
      resultMsg: '',
      userCount: 0,
      isParticipated: false,
      buttonStatus: 1, // 按鈕狀態：1-已參與未開獎, 2-未參與, 3-已參與並中獎, 4-未到達開獎條件, 5-已參與未中獎
      countdownTime: { hours: 0, minutes: 0, seconds: 0 },
      timer: null,
      time: null,
      isFirstLoad: true,//标记是否是初次加载
      rebateDetails: [],
      // 添加本地控制属性
      localVisible: false,
      // 添加抽奖次数数据
      lotteryCount: 0,
      PayAmount: 0,
      PayAmountLabel: '75만원', // 韩国站固定档位展示文案
      RebateData: {
        // 添加抽奖次数数据
        code: '',
        codeUrl: '',
      },
      counter: 0,
      probabilities: [],// 存储从后端获取的概率数据
      lotteryRecordList: [],
      prizeData: {}
    };
  },
  computed: {
    // 根据当前站点的二级域名切换返利券弹窗图片
    couponPopupImage() {
      if (getSecondLevelDomain() === 'kodaduck') {
        return 'https://cdn-download.kodaduck.com/image/cms/20260810/a4fc8564c8a74516a75ebbde42872d7c.png'
      }
      return 'https://cdn-download.dustyx.com/image/act/activity/coupon.png'
    },
    isPrizePoolHidden() {
      return this.$cache.getGameCode() == 'sgyjltw' || this.$cache.getGameCode() == 'fzsgkr' || this.$cache.getGameCode() == 'lycqkr'
    },
    tabWidth() {
      return this.isPrizePoolHidden ? '100%' : '50%'
    },
    dailyStatus() {
      if (this.lotteryCount > 0) {
        return this.$t('couponLottery.unlocked_extra', { amount: this.lotteryCount })
      }
      return this.$t('couponLottery.draws_used_up')
    },
    // 点击奖池开奖按钮内容
    displayResultMsg() {
      return this.resultMsg || this.$t('couponLottery.view_results_now')
    },
    // 参与人数
    poolTitle() {
      return this.isParticipated ? this.$t('couponLottery.current_pool') : this.$t('couponLottery.current_pool_not')
    },
    // 按钮文案
    buttonText() {
      switch (this.buttonStatus) {
        case 1: return this.$t('couponLottery.btn_check_result')
        case 2: return this.$t('couponLottery.btn_not_participated')
        case 3: return this.$t('couponLottery.btn_won')
        case 4: return this.$t('couponLottery.btn_insufficient_participants')
        case 5: return this.$t('couponLottery.btn_won')
        case 6: return this.$t('couponLottery.btn_not_won'); // 已参与未中奖
        default: return this.$t('couponLottery.view_results_now')
      }
    },
    // 按钮样式类名
    buttonClass() {
      return {
        'is-disabled': this.buttonStatus === 2 || this.buttonStatus === 4 || this.buttonStatus === 6,
        'is-won': this.buttonStatus === 5
      }
    },
    // 按钮是否禁用
    isButtonDisabled() {
      // 只有 1-已參與未開獎 可以點擊
      return this.buttonStatus !== 1
    },
    // 規則說明配置數據
    rulesSections() {
      const gameCode = this.gameData && this.gameData.gameCode ? this.gameData.gameCode : this.$cache.getGameCode()
      if (gameCode == 'fzsgkr') {
        return [
          {
            title: '1. 기본 페이백(고정 10%)',
            items: [
              {
                lines: [
                  '공식 웹에서 임의 금액 충전 시, 즉시 10% 금전 쿠폰 페이백 추가 획득.',
                  '예: 100금전 쿠폰를 충전하면, 실제 110금전 쿠폰 획득 가능.'
                ]
              }
            ]
          },
          {
            title: '2. 페이백 쿠폰 추첨(랜덤으로 10%~20% 페이백 쿠폰 획득)',
            items: [
              {
                lines: [
                  '추첨을 통해 페이백 쿠폰을 획득할 수 있으며, 쿠폰의 페이백 비율은 기본 페이백 기준에서 증가됩니다.',
                  '페이백 최고 30%(기본 10% + 쿠폰 최대 20%)입니다.',
                  '예시: 100금전 쿠폰를 충전하고 20% 페이백 쿠폰을 사용할 경우:',
                  '최종 획득 금전 쿠폰 = 100금전 쿠폰 × (1 + 10% 기본 + 20% 쿠폰) = 130금전 쿠폰(총 30% 페이백)'
                ]
              }
            ]
          },
          {
            title: '추첨 기회 획득',
            items: [
              {
                lines: [
                  '1.매일 로그인 보상: 매일 공식 웹에 첫 로그인시 무료 추첨 1회 지급.',
                  '2.충전 추가 보상: 단일 누적 충전 금액이 이하 단계에 도달하면 추가 추첨 기회를 지급합니다(추가 기회는 매일 최대 3회).',
                  '- 300만원 이상 충전 시 → 추첨 1회 추가',
                  '- 600만원 이상 충전 시 → 추첨 2회 추가',
                  '- 900만원 이상 충전 시 → 추첨 3회 추가',
                  '3.1일 추첨 총 횟수 상한은 4회(무료 1회 + 추가 최대 3회)입니다.',
                  '4.페이백 획득 확률:',
                  '-10% 페이백 쿠폰: 62%',
                  '-15% 페이백 쿠폰: 27%',
                  '-20% 페이백 쿠폰: 8%'
                ]
              }
            ]
          },
          {
            title: '페이백 쿠폰 사용',
            items: [
              {
                lines: [
                  '1.페이백 쿠폰의 유효기간은 24시간(획득 시점부터 계산)이니, 반드시 기간 내에 사용해주시기 바랍니다.',
                  '2.페이백 쿠폰은 공식 웹충전에만 적용되며, 제3자 대리 충전이나 기프트 카드에는 적용되지 않습니다.',
                  '3.공홈 중 패키지 상점의 상품은 페이백 이벤트에 적용 불가합니다.'
                ]
              }
            ]
          }
        ]
      }
      if (gameCode == 'lycqkr') {
        return [
          {
            title: '페이백 안내',
            items: [
              {
                subTitle: '1. 기본 페이백 (고정 10%)',
                lines: [
                  '공식 웹사이트에서 금액에 관계없이 충전하면 10% 추가 보상을 즉시 받을 수 있습니다.',
                  '예시: 금괴 100개를 충전하면 실제로 금괴 110개가 지급됩니다.'
                ]
              },
              {
                subTitle: '2. 페이백 쿠폰 추첨 (5%~20% 쿠폰 무작위 획득)',
                lines: [
                  '추첨을 통해 페이백 쿠폰을 획득할 수 있으며, 쿠폰의 페이백 비율은 기본 페이백에 추가로 적용됩니다.',
                  '총 페이백 한도는 30%(기본 10% + 쿠폰 최대 20%)입니다.',
                  '예시: 금괴 100개를 충전하면서 30% 페이백 쿠폰을 사용한 경우, 최종 지급량은 100 x (1 + 기본 10% + 쿠폰 20%) = 금괴 130개(총 페이백 30%)입니다.'
                ]
              }
            ]
          },
          {
            title: '추첨 기회 획득',
            items: [
              {
                lines: [
                  { key: '매일 로그인 보상: 매일 처음 공식 웹사이트에 로그인하면 무료 추첨 기회 1회가 지급됩니다.', prefix: '•' },
                  { key: '충전 추가 보상: 하루 누적 충전 금액이 다음 기준에 도달하면 추가 추첨 기회가 해제됩니다(매일 최대 3회):', prefix: '•' },
                  { key: '75만원 충전 -> 추가 추첨 1회', prefix: '-', indent: true },
                  { key: '200만원 충전 -> 추가 추첨 2회', prefix: '-', indent: true },
                  { key: '400만원 충전 -> 추가 추첨 3회', prefix: '-', indent: true },
                  { key: '하루 추첨 횟수는 최대 4회(무료 1회 + 추가 최대 3회)입니다.', prefix: '•' },
                  { key: '추첨 확률:', prefix: '•' },
                  { key: '5% 페이백 쿠폰: 60%', prefix: '-', indent: true },
                  { key: '10% 페이백 쿠폰: 37%', prefix: '-', indent: true },
                  { key: '15% 페이백 쿠폰: 2.5%', prefix: '-', indent: true },
                  { key: '20% 페이백 쿠폰: 0.5%', prefix: '-', indent: true }
                ]
              }
            ]
          },
          {
            title: '페이백 쿠폰 사용',
            items: [
              {
                lines: [
                  { key: '페이백 쿠폰의 유효 기간은 획득 시점부터 24시간입니다. 기간 내에 사용해 주세요.', prefix: '•' },
                  { key: '페이백 쿠폰은 공식 웹사이트 직접 충전에만 사용할 수 있으며, 제3자 대리 충전이나 기프트 카드에는 적용되지 않습니다.', prefix: '•' },
                  { key: '공식 웹사이트의 패키지 상품에는 페이백 쿠폰을 사용할 수 없습니다.', prefix: '•' },
                  { key: '고액 송금은 해당 페이백 이벤트 대상에서 제외됩니다.', prefix: '•' }
                ]
              }
            ]
          },
          {
            title: '《행운의 대박 추첨》 이벤트 규칙',
            items: [
              {
                slogan: '매일 공식 웹사이트에서 충전하고 대박 추첨에 도전하세요! 행운의 주인공은 바로 당신입니다!'
              },
              {
                subTitle: '【참여 자격】',
                lines: [
                  { key: '이벤트 기간 중 매일 00:00~23:59(UTC+8)에 공식 웹사이트에서 금액에 관계없이 제3자 결제 충전을 완료해야 합니다.', prefix: '•' },
                  { key: '조건을 충족한 플레이어는 별도 신청 없이 당일 추첨 풀에 자동 등록됩니다.', prefix: '•' }
                ]
              },
              {
                subTitle: '【추첨 방식】',
                lines: [
                  { key: '추첨 시간: 매일 오전 10:00(UTC+8)', prefix: '•' },
                  { key: '추첨 대상: 전일 00:00~23:59(UTC+8) 사이 공식 웹사이트에서 충전한 플레이어', prefix: '•' },
                  { key: '추첨 조건: 당일 추첨 풀 참여자가 10명 이상이어야 합니다. 기준 인원에 미달하면 해당 일자의 추첨은 취소되며 추가 추첨은 진행되지 않습니다.', prefix: '•' },
                  { key: '당첨자 명단: 추첨 풀 화면에서 매일 당첨자 명단을 확인할 수 있습니다.', prefix: '•' }
                ]
              },
              {
                subTitle: '【보상 내용】',
                lines: ['25% 페이백 쿠폰 x1']
              },
              {
                subTitle: '【25% 페이백 쿠폰 사용 규칙】',
                lines: [
                  { key: '사용 범위: 최대 45만원 충전 상품에 사용 가능', prefix: '•' },
                  { key: '사용 방법: 충전 시 쿠폰을 선택하면 화면의 페이백 비율에 25%가 자동으로 추가됩니다. 이 상태에서 결제하면 25% 페이백을 받을 수 있습니다.', prefix: '•' },
                  { key: '유효 기간: 획득 후 24시간 이내에 사용해야 하며, 기간이 지나면 무효가 됩니다.', prefix: '•' },
                  { key: '유의 사항: 각 충전 건당 쿠폰 1장만 사용할 수 있으며 다른 페이백 쿠폰과 함께 사용할 수 없습니다. 당일 충전한 플레이어는 충전 횟수와 관계없이 하루 1회만 추첨 자격이 인정되며 자격은 누적되지 않습니다.', prefix: '•' }
                ]
              },
              {
                subTitle: '【유의 사항】',
                lines: [
                  { key: '본 이벤트는 공식 웹사이트의 제3자 결제 충전에만 적용되며 게임 내 충전은 제외됩니다.', prefix: '•' },
                  { key: '악의적인 충전 후 환불, 허위 충전 등 위반 행위가 확인되면 이벤트 자격이 취소되고 지급된 보상이 회수됩니다.', prefix: '•' },
                  { key: '본 이벤트의 최종 해석권은 운영팀에 있습니다.', prefix: '•' }
                ]
              }
            ]
          }
        ]
      }
      if (gameCode == 'sgyjltw') {
        return [
        {
          title: '🏷️ 每日登入・返利券天天領',
          items: [
            {
              lines: [
                '✨ 活動期間每日登入官網，即可直接領取 10%～50% 返利券x1張！'
              ]
            },
            {
              subTitle: '📋 活動規則',
              lines: []
            }
          ]
        },
        {
          title: '一、🧾 領取資格',
          items: [
            {
              lines: [
                '📅 每日 00:00 – 23:59 (UTC+8) 期間，登入官網自動獲得當日返利券。',
                '📌 每個帳號每日限領一次，當日未領取則視同放棄，不另行補發。'
              ]
            }
          ]
        },
        {
          title: '二、🏷️ 返利券內容',
          items: [
            {
              lines: [
                '🎟️ 隨機獲得 10%、15%、25%、50% 其中一種面額的返利券。',
                '💡 舉例：抽到 20% 返利券，儲值時勾選使用可額外獲得 20% 的代金券回饋。'
              ]
            }
          ]
        },
        {
          title: '三、🎁 如何使用返利券？',
          items: [
            {
              lines: [
                '✅ Step 1：在官網選擇欲購買的「代金券禮包」。',
                '✅ Step 2：先勾選您持有的返利券，再選擇 指定支付管道 完成付款。',
                '👀 勾選返利券後，系統會自動顯示該管道適用的返利比例；若無顯示，則代表該管道暫不支援此活動。',
                '💡 小提醒：務必先勾選返利券再結帳，才能享有加碼回饋喔！'
              ]
            },
            {
              subTitle: '📌 計算範例（以 $9.99 代金券禮包 + 20% 返利券為例）：',
              lines: [
                '原得 999 代金券',
                '加碼 999 × 20% = 199 代金券',
                '總共獲得 1,198 代金券'
              ]
            }
          ]
        },
        {
          title: '四、⏳ 有效期限',
          items: [
            {
              lines: [
                '⏰ 返利券領取後 24 小時內 須使用完畢，逾期自動失效，恕不補發。',
                '🔝 部分高額度返利券設有最高可使用金額限制，請於使用時留意系統提示。'
              ]
            }
          ]
        },
        {
          title: '五、🏆 哪裡查看？',
          items: [
            {
              lines: [
                '🔔 登入官網後，前往「返利券」專區即可看到每日領取的返利券及其有效時間。'
              ]
            }
          ]
        },
        {
          title: '六、🎲 抽取概率',
          items: [
            {
              lines: [
                '◆ 10% 返利券 ................ 60%',
                '◆ 15% 返利券 ................ 15%',
                '◆ 25% 返利券 ................ 10%',
                '◆ 50% 返利券 ................ 5%'
              ]
            }
          ]
        },
        {
          title: '七、⚠️ 注意事項',
          items: [
            {
              lines: [
                '◆ 本活動不得與其他官網活動使用或疊加。',
                '◆ 官方保留活動最終修改與解釋權。',
                '◆ 如發現違規或利用漏洞參加者，官方有權取消其得獎及使用資格。'
              ]
            }
          ]
        }
        ]
      }
      return [
        {
          title: 'couponLottery.rules_rebate_title',
          items: [
            {
              subTitle: 'couponLottery.rules_rebate_base_title',
              lines: ['couponLottery.rules_rebate_base_desc', 'couponLottery.rules_rebate_base_example']
            },
            {
              subTitle: 'couponLottery.rules_rebate_draw_title',
              lines: ['couponLottery.rules_rebate_draw_desc_1', 'couponLottery.rules_rebate_draw_desc_2', 'couponLottery.rules_rebate_draw_example']
            }
          ]
        },
        {
          title: 'couponLottery.rules_chance_title',
          items: [
            {
              lines: [
                { key: 'couponLottery.rules_chance_login_desc', prefix: '•' },
                { key: 'couponLottery.rules_chance_recharge_title', prefix: '•' },
                { key: 'couponLottery.rules_chance_recharge_item_1', prefix: '-', indent: true },
                { key: 'couponLottery.rules_chance_recharge_item_2', prefix: '-', indent: true },
                { key: 'couponLottery.rules_chance_recharge_item_3', prefix: '-', indent: true },
                { key: 'couponLottery.rules_chance_limit', prefix: '•' },
                { key: 'couponLottery.rules_chance_rates_title', prefix: '•' },
                { key: 'couponLottery.rules_chance_rate_10', prefix: '-', indent: true },
                { key: 'couponLottery.rules_chance_rate_15', prefix: '-', indent: true },
                { key: 'couponLottery.rules_chance_rate_25', prefix: '-', indent: true },
                { key: 'couponLottery.rules_chance_rate_50', prefix: '-', indent: true }
              ]
            }
          ]
        },
        {
          title: 'couponLottery.rules_usage_title',
          items: [
            {
              lines: [
                { key: 'couponLottery.rules_usage_item_1', prefix: '•' },
                { key: 'couponLottery.rules_usage_item_2', prefix: '•' },
                { key: 'couponLottery.rules_usage_item_3', prefix: '•' },
                { key: 'couponLottery.rules_usage_item_4', prefix: '•' }
              ]
            }
          ]
        },
        {
          title: 'couponLottery.rules_activity_title',
          items: [
            { slogan: 'couponLottery.rules_activity_slogan' },
            {
              subTitle: 'couponLottery.rules_activity_qual_title',
              lines: [
                { key: 'couponLottery.rules_activity_qual_item_1', prefix: '•' },
                { key: 'couponLottery.rules_activity_qual_item_2', prefix: '•' }
              ]
            },
            {
              subTitle: 'couponLottery.rules_activity_mech_title',
              lines: [
                { key: 'couponLottery.rules_activity_mech_item_1', prefix: '•' },
                { key: 'couponLottery.rules_activity_mech_item_2', prefix: '•' },
                { key: 'couponLottery.rules_activity_mech_item_3', prefix: '•' },
                { key: 'couponLottery.rules_activity_mech_item_4', prefix: '•' }
              ]
            },
            {
              subTitle: 'couponLottery.rules_activity_reward_title',
              lines: ['couponLottery.rules_activity_reward_item']
            },
            {
              subTitle: 'couponLottery.rules_activity_reward_usage_title',
              lines: [
                { key: 'couponLottery.rules_activity_reward_usage_item_1', prefix: '•' },
                { key: 'couponLottery.rules_activity_reward_usage_item_2', prefix: '•' },
                { key: 'couponLottery.rules_activity_reward_usage_item_3', prefix: '•' },
                { key: 'couponLottery.rules_activity_reward_usage_item_4', prefix: '•' }
              ]
            },
            {
              subTitle: 'couponLottery.rules_activity_notes_title',
              lines: [
                { key: 'couponLottery.rules_activity_notes_item_1', prefix: '•' },
                { key: 'couponLottery.rules_activity_notes_item_2', prefix: '•' },
                { key: 'couponLottery.rules_activity_notes_item_3', prefix: '•' }
              ]
            }
          ]
        }
      ]
    },
    // 时间渲染
    countdownDisplay() {
      const { hours, minutes, seconds } = this.countdownTime
      return `${this.$t('couponLottery.countdown_prefix')}${this.$t('couponLottery.time_h_m_s', { hours, minutes, seconds })}`
    },
    availableCouponsCount() {
      return Array.isArray(this.rebateDetails) ? this.rebateDetails.length : 0;
    }
  },
  async created() {
    this.startCountdown();
    //其他地区临时处理
    if (this.$cache.getGameCode() != 'cztxtw' && this.$cache.getGameCode() != 'sgyjltw' && this.$cache.getGameCode() != 'fzsgkr' && this.$cache.getGameCode() != 'lycqkr') {
      return
    }
    if (!this.isPrizePoolHidden) {
      await this.initPrizePool();
    }
    await this.InventoryData()
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    if (this.time) {
      clearInterval(this.time);
    }

  },
  async mounted() {
    // 组件挂载后检查抽奖次数
    const loginData = this.$cache.getLoginData();
    // 判断是否是测试环境(后续需后台做开关判断)
    if (this.$cache.getGameCode() == 'cztxtw' || this.$cache.getGameCode() == 'sgyjltw' || this.$cache.getGameCode() == 'fzsgkr' || this.$cache.getGameCode() == 'lycqkr') {
      const response = await this.$axios({
        method: 'get',
        url: '/web/api/act/getActivity',
        params: {
          gameCode: this.$cache.getGameCode(),
          activityCode: this.$cache.getGameCode() + "RebateAct"
        }
      });
      if (response.code === 1000) {
      } else {
        return;
      }
    } else {
      return;
    }

    //其他地区临时处理
    if (this.$cache.getGameCode() != 'cztxtw' && this.$cache.getGameCode() != 'sgyjltw' && this.$cache.getGameCode() != 'fzsgkr' && this.$cache.getGameCode() != 'lycqkr') {
      return
    }

    await this.loadData();
    this.time = setInterval(() => {
      // 每秒递减每个优惠券的剩余时间
      if (!Array.isArray(this.rebateDetails) || this.rebateDetails.length === 0) {
        return;
      }

      this.rebateDetails.forEach(coupon => {
        // 确保 endTime 存在且大于 0
        if (typeof coupon.endTime === 'number' && coupon.endTime > 0) {
          coupon.endTime -= 1; // 每秒递减
          this.counter++; // 可选：统计总递减次数
        }
      });
    }, 1000);
  },
  methods: {
    getRuleText(text) {
      if (typeof text !== 'string') {
        return ''
      }
      return text.indexOf('couponLottery.') === 0 ? this.$t(text) : text
    },
    getRebateCouponUserId() {
      const userId = this.$session.getUserId()
      const token = this.$session.getLoginToken()
      if (!this.$session.hasLogin() || !userId || !token) {
        $("#loginWindow").bPopup();
        return null
      }
      return userId
    },
    getRebateCouponAuthHeaders() {
      return {
        'X-Auth-Token': this.$session.getLoginToken()
      }
    },
    // 供父组件调用的刷新方法
    refreshData() {
      
      this.InventoryData();
      //临时处理
      if (this.$cache.getGameCode() == 'cztxtw' || this.$cache.getGameCode() == 'sgyjltw' || this.$cache.getGameCode() == 'fzsgkr' || this.$cache.getGameCode() == 'lycqkr') {
        this.loadData();
        if (!this.isPrizePoolHidden) {
          this.initPrizePool();
        }
      }
      
    },
    getCountdown(remainingSeconds) {
      let seconds = Math.floor(remainingSeconds);
      const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
      const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
      return `${this.$t('couponLottery.remaining_time')}${this.$t('couponLottery.time_h_m', { hours, minutes })}`
    },
    // 启动实时倒计时更新
    startRealTimeCountdown() {
      // 清除之前的定时器
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
      }

      // 每秒更新一次
      this.countdownTimer = setInterval(() => {
        // 强制更新视图
        this.$forceUpdate();

        // 检查是否有优惠券已过期
        this.rebateDetails.forEach(coupon => {
          if (coupon.endTime) {
            const now = Date.now();
            const end = new Date(coupon.endTime).getTime();
            if (now >= end) {
              // 可以在这里处理过期逻辑
              coupon.isExpired = true;
            }
          }
        });
      }, 1000);
    },
    // 统一的关闭方法
    closeModal() {
      this.$emit('close');
      // 如果需要也可以重置本地状态
      this.localVisible = false;
    },
    async InventoryData() {
      const userId = this.getRebateCouponUserId()
      if (!userId) return
      try {
        const response = await this.$axios({
          method: 'get',
          url: '/web/api/act/rebateCoupon/item',
          headers: this.getRebateCouponAuthHeaders(),
          params: {
            userId,
            gameCode: this.$cache.getGameCode()
          }
        });
        if (response.code === 1000) {
          console.log(response);
          this.rebateDetails = response.data.rebateDetails

        }
      } catch (error) {
        console.error('请求抽奖接口出错:', error);
      }
    },
    async loadData() {
      const userId = this.getRebateCouponUserId()
      if (!userId) return
      try {
        const response = await this.$axios({
          method: 'get',
          url: '/web/api/act/rebateCoupon/init-data',
          headers: this.getRebateCouponAuthHeaders(),
          params: {
            userId,
            gameCode: this.$cache.getGameCode()
          }
        });
        if (response.code === 1000) {
          if (this.$session.hasLogin()) {
            this.lotteryCount = response.data.lotteryCount || 0;
            this.$emit('lottery-count-change', this.lotteryCount);
            this.probabilities = response.data.ruleText
            // 仅在初次加载时判断是否显示组件
            if (this.isFirstLoad) {
              if (this.lotteryCount > 0) {
                this.localVisible = true;
              } else {
                this.localVisible = false;
              }
              this.isFirstLoad = false; // 设置为非初次加载
            }
            if (response.data.payAmount >= response.data.gearThree) {
              this.percentage = 100
              if (this.$cache.getGameCode() === 'lycqkr') this.PayAmountLabel = '400만원'
            } else if (response.data.payAmount >= response.data.gearTwo) {
              //截断小数
              let count = Math.trunc(response.data.payAmount / (response.data.gearThree / 100));
              this.percentage = count
              this.PayAmount = response.data.gearThree
              if (this.$cache.getGameCode() === 'lycqkr') this.PayAmountLabel = '400만원'
            } else if (response.data.payAmount >= response.data.gearOne) {
              //截断小数
              let count = Math.trunc(response.data.payAmount / (response.data.gearTwo / 100));
              this.percentage = count
              this.PayAmount = response.data.gearTwo
              if (this.$cache.getGameCode() === 'lycqkr') this.PayAmountLabel = '200만원'
            } else {
              //截断小数
              let count = Math.trunc(response.data.payAmount / (response.data.gearOne / 100));
              this.percentage = count
              this.PayAmount = response.data.gearOne
              if (this.$cache.getGameCode() === 'lycqkr') this.PayAmountLabel = '75만원'
            }
            // 启动实时倒计时
            this.$nextTick(() => {
              this.startRealTimeCountdown();
            });
          }
        }
      } catch (error) {
        console.error('请求抽奖接口出错:', error);
      }
    },
    // 奖池次日十点倒计时
    startCountdown() {
      const update = () => {
        const now = new Date();
        const target = new Date();
        // 目标时间是次日 10:00:00
        target.setDate(target.getDate() + 1);
        target.setHours(10, 0, 0, 0);

        const diff = target - now;
        if (diff <= 0) {
          this.countdownTime = { hours: 0, minutes: 0, seconds: 0 };
          return;
        }

        const h = Math.floor(diff / (1000 * 60 * 60));
        const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const s = Math.floor((diff % (1000 * 60)) / 1000);

        this.countdownTime = { hours: h, minutes: m, seconds: s };
      };

      update();
      this.timer = setInterval(update, 1000);
    },
    // 初始值请求并且渲染
    async initPrizePool() {
      if (this.isPrizePoolHidden) {
        return
      }
      try {
        const response = await this.$axios({
          method: 'get',
          url: '/web/api/act/ActRechargePrizePoolInit',
          params: {
            userId: this.$session.getUserId(),
            gameCode: this.$cache.getGameCode(),
            roleId: this.roleInfo.roleId,
            roleName: this.roleInfo.roleName,
          }
        });

        if (response.code === 1000) {
          // 初始化成功，可以根据返回的数据更新组件状态
          this.userCount = response.data.userCount
          this.buttonStatus = response.data.buttonStatus// 保存按钮状态
          this.lotteryRecordList = response.data.lotteryRecordList
          if (response.data.todayStatus === 1) {
            this.isParticipated = true
          } else if (response.data.todayStatus === 2) {
            this.isParticipated = false
          }
        } else {
          console.error('奖池初始化失败:', response.message);
        }
      } catch (error) {
        console.error('请求奖池初始化接口出错:', error);
      }
    },
    async handlShowCouponPopup() {
      const userId = this.getRebateCouponUserId()
      if (!userId) return
      if (this.lotteryCount == 0) {
        this.$refs.tips.show(this.$i18n.tc('insufficient_lottery_count_text'));
        return
      }
      if (this.isDrawing) return
      this.isDrawing = true
      const analyticsProperties = { activity_id: 'rebate_coupon_lottery', activity_name: '返利券抽奖', activity_type: 'lottery' }
      this.$analytics.track('activity_join_requested', analyticsProperties)
      try {
        // 发送抽奖请求
        const response = await this.$axios({
          method: 'get',
          url: '/web/api/act/rebateCoupon/lottery',
          headers: this.getRebateCouponAuthHeaders(),
          params: {
            userId,
            gameCode: this.$cache.getGameCode()
          }
        });

        if (response.code === 1000) {
          this.$analytics.track('activity_join_succeeded', analyticsProperties)
          this.$analytics.track('activity_completed', analyticsProperties)
          // 模拟抽奖延迟
          await new Promise(resolve => setTimeout(resolve, 1500))
          this.RebateData = {
            code: response.data.code.replace("Rebate", ""),
            codeUrl: response.data.codeUrl,
          }
          this.isDrawing = false
          this.showCouponPopup = false
          this.showResultPopup = true
          confetti({
            particleCount: 200,
            spread: 60,
            origin: { y: 0.6 },
            zIndex: 999999
          });
          this.loadData()
          this.InventoryData()
        } else {
          // 抽奖失败
          this.$analytics.track('activity_join_failed', { ...analyticsProperties, reason: 'business_rejected', error_code: response.code })
          this.$refs.tips.show(response.message || '抽奖失败');
          this.isDrawing = false
        }
      } catch (error) {
        this.$refs.tips.show(this.$i18n.tc('network_error_retry_text'));
        this.$analytics.track('activity_join_failed', { ...analyticsProperties, reason: 'network_error' })
        this.isDrawing = false
      }
    },
    // 点击参加奖池开奖事件
    async handlShowWinPopup() {
      if (this.isPrizePoolHidden) {
        return
      }
      try {
        const response = await this.$axios({
          method: 'get',
          url: '/web/api/act/getRechargePrizePoolPrize',
          params: {
            userId: this.$session.getUserId(),
            gameCode: this.$cache.getGameCode()
          }
        });

        if (response.code === 1000) {
          this.prizeData = response.data
          this.resultMsg = this.$t('couponLottery.msg_1000')
          confetti({
            particleCount: 200, // 彩带粒子数量
            spread: 60, // 彩带扩散角度（越大越分散）
            origin: { y: 0.6 }, // 发射原点（y: 0.6 表示页面60%高度位置，0=顶部，1=底部）
            zIndex: 999999
          });
          this.showWinPopup = true
          if (!this.isPrizePoolHidden) {
            this.initPrizePool()
          }
          console.log('抽奖成功:', response.data);
        } else if (response.code === 5003) {
          this.resultMsg = this.$t('couponLottery.msg_5003')
        } else if (response.code === 5004) {
          this.resultMsg = this.$t('couponLottery.msg_5004')
        } else {
          console.error('抽奖失败:', response.message);
        }
      } catch (error) {
        console.error('请求抽奖接口出错:', error);
      }
    },
    handleClick(tab, event) {
      console.log(tab.index);
      if (tab.name === 'first' && !this.isPrizePoolHidden) {
        this.initPrizePool()
      } else if (tab.name === 'second') {
        this.InventoryData()
      }

    },
    // 点击兑换
    async handleExchange() {
      if (!this.redemptionCode || this.isExchanging) return
      const userId = this.getRebateCouponUserId()
      if (!userId) return
      this.isExchanging = true
      try {
        const response = await this.$axios({
          method: 'get',
          url: '/web/api/act/rebateCoupon/gift',
          headers: this.getRebateCouponAuthHeaders(),
          params: {
            userId,
            gameCode: this.$cache.getGameCode(),
            giftCode: this.redemptionCode
          }
        });
        if (response.code === 1000) {
          // 兑换成功，弹出成功提示
          this.$analytics.track('activity_reward_claimed', { activity_id: 'rebate_coupon_lottery', activity_name: '返利券抽奖', activity_type: 'lottery' })
          this.InventoryData()
          this.$refs.tips.show(this.$t('couponLottery.exchange_success'))
        } else {
          console.error('兑换失败:', response.message);
          this.$refs.tips.show(response.message || this.$t('couponLottery.exchange_failed'));
        }
      } catch (error) {
        console.error('请求抽奖接口出错:', error);
      }
      this.$emit('exchange', this.redemptionCode)
      this.isExchanging = false
    },
  }
}
</script>

<style scoped>
::v-deep .el-tabs {
  width: 90%;
  margin: auto;
}

::v-deep .el-tabs__nav {
  float: none !important;
  background-color: #644829 !important;
  border-radius: .14rem;
  display: flex;
  overflow: hidden;
  border: none !important;
}

::v-deep .el-tabs__item {
  color: #fff;
  height: .56rem;
  line-height: .56rem;
  border: none !important;
}

::v-deep .el-tabs__item.is-active {
  background: #FBEABB !important;
  color: #58351A;
}

::v-deep .el-tabs--card .el-tabs__header {
  margin: 0 0 15px 0;
  border-bottom: none;
  border-radius: .14rem;
  overflow: hidden;
  background-color: transparent !important;
}

::v-deep .el-tabs__item:first-child {
  text-align: center;
  width: 50%;
}

::v-deep .el-tabs__item:last-child {
  text-align: center;
  width: 50%;
}

::v-deep .el-tabs.is-single-tab .el-tabs__item {
  width: 100%;
}

::v-deep .el-tabs.is-single-tab .el-tabs__header {
  display: none;
}


@media (max-width: 768px) {
  ::v-deep .el-tabs__item {
    padding: 0 .1rem !important;
    font-size: .2rem;
    height: .5rem;
    line-height: .5rem;
  }

  ::v-deep .el-tabs__nav {
    border-radius: .1rem;
  }

  .next-draw {
    padding: .22rem;
  }
}
</style>
